module.exports = "<div class=\"pop-700\">\n  <header class=\"dialog-header flex-item\">\n    <h2>Session Expired</h2>\n  </header>\n  <div>\n    It looks like your session has expired. Please refresh your browser window or click the Reload button to continue.\n  </div>\n  <md-card-actions>\n    <div>\n      <div class=\"table-cell\">\n        <div class=\"col v-middle\">\n          <button md-raised-button class=\"ml-10\" (click)=\"reloadWindow()\">Reload</button>\n        </div>\n      </div>\n    </div>\n  </md-card-actions>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/sessionexpired/session-expired.component.html
// module id = 2344
// module chunks = 0